import * as _ from 'lodash';

import { Form } from './form';
import { Attribute } from '../attributes/attribute';
import { FormAttributeDefinition } from './formAttributeDefinition';
import { FormPage } from './formPage';

export class Application {
  form: Form;
  email: string;
  questions: FormAttributeDefinition[];
  pages: FormPage[];
  publicTeamName: string;
  teamName: string;

  get hasExpired(): boolean {
    if (!this.form) return false;
    return this.form.hasExpired;
  }

  public filterForShowCurrentValues(values: Array<Attribute>): Array<Attribute> {
    let filtered = _.filter(values, (attribute) => {
      let attributeDefinition = _.find(
        this.questions,
        (attributeDefinition) => attributeDefinition.id == attribute.attributeDefinitionId
      );
      return attributeDefinition ? attributeDefinition.showCurrentValue || attribute.edited : false;
    });
    return filtered;
  }

  static parse(data): Application {
    if (!data) return;

    var application = new Application();
    application.email = data.email;
    application.form = Form.parse(data.form);
    application.questions = _.map(data.questions, FormAttributeDefinition.parse);
    application.pages = data.pages;
    application.teamName = data.teamName;
    application.publicTeamName = data.publicTeamName;
    return application;
  }

  static blank(): Application {
    var application = new Application();
    application.form = new Form();
    application.pages = [];
    return application;
  }
}
